var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160618",
    "data-name": "Group 160618",
    transform: "translate(-1828 -398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_147727",
    "data-name": "Rectangle 147727",
    transform: "translate(1828 398)",
    fill: "#f5f7f8",
    stroke: "rgba(112,112,112,0.15)",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-share-2",
    "data-name": "Icon feather-share-2",
    transform: "translate(1835 406.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37651",
    "data-name": "Path 37651",
    d: "M27,5.25A2.25,2.25,0,1,1,24.75,3,2.25,2.25,0,0,1,27,5.25Z",
    transform: "translate(-9)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37652",
    "data-name": "Path 37652",
    d: "M9,15.75A2.25,2.25,0,1,1,6.75,13.5,2.25,2.25,0,0,1,9,15.75Z",
    transform: "translate(0 -5.25)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37653",
    "data-name": "Path 37653",
    d: "M27,26.25A2.25,2.25,0,1,1,24.75,24,2.25,2.25,0,0,1,27,26.25Z",
    transform: "translate(-9 -10.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37654",
    "data-name": "Path 37654",
    d: "M12.885,15.015,18.007,18M18,9.765,12.885,12.75",
    transform: "translate(-4.193 -3.382)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.e3e13765f3b4d39a2da497c0e2f631df.svg";
export { ForwardRef as ReactComponent };